import React from "react";
import { Phone, MapPin } from "lucide-react";

const people = [
  {
    city: "Bengaluru",
    name: "Mandar Prabhudesai",
    role: "Founder & Strategic Architect",
    phone: "+91 99725 54702",
    tel: "+919972554702",
  },
  {
    city: "Nagpur",
    name: "Sweta Bhushan",
    role: "Programme Advisor",
    phone: "+91 95036 73348",
    tel: "+919503673348",
  },
  {
    city: "Indore",
    name: "Kunika Choudhary",
    role: "Programme Advisor",
    phone: "+91 99819 92846",
    tel: "+919981992846",
  },
];

export default function RegionalPresence() {
  return (
    <section
      id="presence"
      data-testid="regional-presence"
      className="px-6 md:px-12 lg:px-24 py-24 md:py-28 border-t border-sebyx-border bg-sebyx-surface/40"
    >
      <div className="flex items-center gap-3 mb-6">
        <span className="block w-8 h-px bg-sebyx-accent" />
        <span className="font-mono text-[11px] tracking-[0.3em] uppercase text-sebyx-accent">
          [05] Where We Are
        </span>
      </div>
      <h2
        data-testid="presence-headline"
        className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tighter text-sebyx-text leading-[1.05]"
      >
        Local faces,{" "}
        <span className="text-sebyx-accent italic font-light">
          not a call centre
        </span>
        .
      </h2>
      <p className="mt-5 font-body text-base text-sebyx-muted max-w-2xl leading-relaxed">
        Met us at MIA, VIA or another industry association? Your local Sebyx
        advisor is one call away — and will meet you at your factory or office.
      </p>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5">
        {people.map((p, i) => (
          <div
            key={p.city}
            data-testid={`presence-card-${i}`}
            className="border border-sebyx-border bg-sebyx-bg p-7"
          >
            <div className="flex items-center gap-2 font-mono text-[11px] tracking-[0.25em] uppercase text-sebyx-accent font-semibold">
              <MapPin size={14} /> {p.city}
            </div>
            <div className="mt-4 font-display text-lg font-semibold text-sebyx-text">
              {p.name}
            </div>
            <div className="font-body text-sm text-sebyx-muted mt-1">
              {p.role}
            </div>
            <a
              href={`tel:${p.tel}`}
              data-testid={`presence-phone-${i}`}
              className="mt-4 inline-flex items-center gap-2 font-mono text-sm text-sebyx-text hover:text-sebyx-accent transition-colors"
            >
              <Phone size={14} /> {p.phone}
            </a>
          </div>
        ))}
      </div>
    </section>
  );
}
